import { APP_NAME } from '@en3/shared';
import { Link } from 'react-router-dom';
import { ROUTES } from '@/app/routes';

/**
 * 页脚：版权声明常驻。
 *
 * 平台的合规底线写在最显眼的位置：不内置受版权保护的教材全文，
 * 正文由具备使用授权的教师/用户自行导入并留痕。
 */
export function Footer() {
  return (
    <footer className="border-t bg-background">
      <div className="mx-auto max-w-5xl px-4 py-6 text-xs text-muted-foreground">
        <p className="leading-relaxed">
          {APP_NAME} · 本平台<b>不内置</b>受版权保护的教材全文，教材目录仅作元数据索引；
          正文需由具备使用授权的教师或用户自行导入，导入时须确认授权并留痕。
        </p>
        <p className="mt-2 flex flex-wrap items-center gap-x-3 gap-y-1">
          <Link className="underline underline-offset-4 hover:text-foreground" to={ROUTES.copyright}>
            版权与数据来源
          </Link>
          <span aria-hidden>·</span>
          <span>词典释义来源：Free Dictionary API（Wiktionary，CC BY-SA）与内置分级词表</span>
        </p>
      </div>
    </footer>
  );
}
